module.exports = __webpack_public_path__ + "img/money-background.99126778.png";